export default "__VITE_ASSET__yzpyi_Bb__"